/* 
  src/reducers/registerReducer.js
*/
const initialState = {
  leftThumbFinger : "",
  leftThumbPathfillOpacity: .1,
  leftIndexOrPointerFinger : "",
  leftIndexPathfillOpacity: .1,
  leftMiddleFinger : "",
  leftMiddlePathfillOpacity: .1,
  leftRingFinger : "",
  leftRingPathfillOpacity: .1,
  leftPinkyFinger : "",
  leftPinkPathfillOpacity: .1,
  rightThumbFinger:  "",
  rightThumbPathfillOpacity: .1,
  rightIndexOrPointerFinger:  "",
  rightIndexPathfillOpacity: .1,
  rightMiddleFinger:  "",
  rightMiddlePathfillOpacity: .1,
  rightRingFinger:  "",
  rightRingPathfillOpacity: .1,
  rightPinkyFinger:  "",
  rightPinkPathfillOpacity: .1,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case 'REGISTER_LEFT_THUMB':{
      return {...state, leftThumbFinger : state.leftThumbFinger.concat(state.leftThumbFinger ? "," + action.payload : action.payload ), leftThumbPathfillOpacity : state.leftThumbPathfillOpacity + .2};
    }
    case 'REGISTER_LEFT_INDEX_OR_POINTER':{
      return {...state, leftIndexOrPointerFinger : state.leftIndexOrPointerFinger.concat(state.leftIndexOrPointerFinger ? "," + action.payload : action.payload ) , leftIndexPathfillOpacity : state.leftIndexPathfillOpacity + .2};
    }
    case 'REGISTER_LEFT_MIDDLE':{
      return{...state, leftMiddleFinger : state.leftMiddleFinger.concat(state.leftMiddleFinger ? "," + action.payload : action.payload ) , leftMiddlePathfillOpacity : state.leftMiddlePathfillOpacity + .2};
    }
    case 'REGISTER_LEFT_RING':{
      return {...state, leftRingFinger : state.leftRingFinger.concat(state.leftRingFinger ? "," + action.payload : action.payload ) , leftRingPathfillOpacity : state.leftRingPathfillOpacity + .2};
    }
    case 'REGISTER_LEFT_PINK':{
      return {...state, leftPinkyFinger : state.leftPinkyFinger.concat(state.leftPinkyFinger ? "," + action.payload : action.payload ) , leftPinkPathfillOpacity : state.leftPinkPathfillOpacity + .2};
    }
    case 'REGISTER_RIGHT_THUMB':{
      return {...state, rightThumbFinger : state.rightThumbFinger.concat(state.rightThumbFinger ? "," + action.payload : action.payload ), rightThumbPathfillOpacity : state.rightThumbPathfillOpacity + .2};
    }
    case 'REGISTER_RIGHT_INDEX_OR_POINTER':{
      return {...state, rightIndexOrPointerFinger : state.rightIndexOrPointerFinger.concat(state.rightIndexOrPointerFinger ? "," + action.payload : action.payload ) , rightIndexPathfillOpacity : state.rightIndexPathfillOpacity + .2};
    }
    case 'REGISTER_RIGHT_MIDDLE':{
      return{...state, rightMiddleFinger : state.rightMiddleFinger.concat(state.rightMiddleFinger ? "," + action.payload : action.payload ) , rightMiddlePathfillOpacity : state.rightMiddlePathfillOpacity + .2};
    }
    case 'REGISTER_RIGHT_RING':{
      return {...state, rightRingFinger : state.rightRingFinger.concat(state.rightRingFinger ? "," + action.payload : action.payload ) , rightRingPathfillOpacity : state.rightRingPathfillOpacity + .2};
    }
    case 'REGISTER_RIGHT_PINK':{
      return {...state, rightPinkyFinger : state.rightPinkyFinger.concat(state.rightPinkyFinger ? "," + action.payload : action.payload ) , rightPinkPathfillOpacity : state.rightPinkPathfillOpacity + .2};
    }
       
    default:
      return state
  }
}